import React from 'react';
import { FilterSelect } from '../../shared/table/FilterSelect';

export const AuditLogFiltersDrawer = ({
    isOpen,
    onClose,
    searchTerm,
    onSearchTermChange,
    entityType,
    entityTypeOptions,
    onEntityTypeChange,
    action,
    actionOptions,
    onActionChange,
    actorUserId,
    actorOptions,
    onActorUserIdChange,
    dateFrom,
    onDateFromChange,
    dateTo,
    onDateToChange,
    rowsPerPage,
    onRowsPerPageChange,
    onClearFilters,
}) => {
    React.useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [isOpen, onClose]);

    if (!isOpen) {
        return null;
    }

    return (
        <div className="ticket-filters-drawer-overlay" onClick={onClose}>
            <aside className="ticket-filters-drawer" onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true" aria-label="Filtros de auditoría">
                <div className="ticket-filters-drawer__header">
                    <div>
                        <h6 className="mb-0 fw-bold">Filtros de auditoría</h6>
                    </div>
                    <button type="button" className="btn btn-sm btn-light" onClick={onClose}>
                        <i className="feather-x" />
                    </button>
                </div>

                <div className="ticket-filters-drawer__body">
                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Buscar</label>
                        <input
                            type="search"
                            className="form-control"
                            placeholder="Código, actor o resumen..."
                            value={searchTerm}
                            onChange={(event) => onSearchTermChange(event.target.value)}
                        />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Entidad</label>
                        <FilterSelect value={entityType} options={entityTypeOptions} onChange={onEntityTypeChange} />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Acción</label>
                        <FilterSelect value={action} options={actionOptions} onChange={onActionChange} />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Actor</label>
                        <FilterSelect value={actorUserId} options={actorOptions} onChange={onActorUserIdChange} />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Desde</label>
                        <input type="date" className="form-control" value={dateFrom} onChange={(event) => onDateFromChange(event.target.value)} />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Hasta</label>
                        <input type="date" className="form-control" value={dateTo} onChange={(event) => onDateToChange(event.target.value)} />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Mostrar</label>
                        <FilterSelect
                            value={rowsPerPage}
                            options={[10, 20, 50, 100].map((value) => ({ value, label: String(value) }))}
                            onChange={(value) => onRowsPerPageChange(Number(value))}
                        />
                    </div>
                </div>

                <div className="ticket-filters-drawer__footer">
                    <button type="button" className="btn btn-outline-secondary w-100" onClick={onClearFilters}>
                        Limpiar filtros
                    </button>
                </div>
            </aside>
        </div>
    );
};